<template lang="pug">
.nav-top.row.center.between(v-if="!$root.mobile")
  .logo.row.center
    img(src="../assets/img/lbc-small-black-nolabel.svg")
  .row.search.flex-1
    input.flex-1(:placeholder="t.search + '...'" v-model="$root.search")
    button.icon
      font-awesome-icon(icon="search")
  button.green.new-idea(@click="$root.modal = { name: 'new_idea' }") {{ t.propose_idea }}
  .row.status-count(v-if="!$root.mobile")
    .indicator.column.center.between(v-for="status in ['submitted', 'confirmed', 'scheduled', 'denied', 'published']" :class="{ [status]: true }")
      .text.row.center {{ t['status_'+status] || t[status] }}
      .value.column.center {{ $root.status_count[status] || 0 }}
  .settings
    button.row.center.icon(@click="menu = true")
      font-awesome-icon(icon="cog")
    menu-top(:show="menu" @close="menu = false")
.nav-top.row.center.between(v-else)
  .logo.row.center
    img(src="../assets/img/lbc-small-black-nolabel.svg")
  .row.search.flex-1
    input.flex-1(:placeholder="t.search + '...'" v-model="$root.search")
    button.icon
      font-awesome-icon(icon="search")
  menu-top(:show="menu" @close="menu = false")
  button.green.new-idea(@click="$root.modal = { name: 'new_idea' }") Proposer une idée

  .row.center.left.settings(@click="menu = !menu")
    .icon
      font-awesome-icon(icon="cog")
</template>
<script>
export default {
  data() {
    return {
      menu: false,
    }
  }
}
</script>
<style>
@media only screen and (max-width: 720px) {
  .status-count { display: none; }
}
.nav-top {
  --height: 54px;
  height: var(--nav-top-height);
  background: transparent;
  position: absolute;
  z-index: 101;
  width: 100%;
  padding: 8px 16px;

}
.nav-top .search {
  height: 54px;
  padding: 0 16px;
}
.nav-top .search input {
  background: rgba(255,255,255,0.6);
  border-radius: 8px 0 0 8px;
  font-size: 18px;
}
.nav-top button {
  height: var(--height);
}
.nav-top .search .icon {
  width: 64px;
  border-radius: 0 8px 8px 0;
  background: white;
}
.nav-top .new-idea {font-weight: bold; border-radius: 8px;}
.laptop .nav-top .new-idea {
  margin: 0 32px 0 16px;
  min-width: 140px;
}
.laptop .nav-top .settings button {
  height: 54px;
  padding: 20px 0 0 0;
  margin-left: 12px;
}
.nav-top .settings button {
  height: 42px;
  width: 42px;
  padding: 8px;
}
.nav-top .status-count > .row {
  padding: 6px;
}
.nav-top .indicator {
  width: 58px;
  margin: 0 8px;
  opacity:
}
.nav-top .indicator .text {
  text-align: center;
  line-height: 1;
  flex: 1;
  font-size: 12px;
  padding: 4px 0;
}
.nav-top .indicator .value {
  min-height: 34px;
  border-radius: 10px;
  width: 100%;
  font-size: 16px;
}
.mobile:not(.laptop) .menu {
  position: fixed;
  top:0;
  left: 0;
  height: 100vh;
}
.mobile:not(.laptop) .hidden-backdrop {
  background: rgba(0,0,0,0.5);
}
.nav-top .menu {
  position: absolute;
  background: white;
  right: 8px;
  top: 42px;
  box-shadow: 0 3px 10.5px 0 rgba(68,102,136,.24);
  z-index: 102;
  width: 240px;
}
.nav-top .menu .header {
  background: var(--primary);
  color: rgba(255,255,255,0.9);
  padding: 8px 16px;
}
.nav-top .menu .header .title {
  font-size: 16px;
  font-weight: bold;
}
.nav-top .menu .header .subtitle {
  font-size: 14px;
}

.nav-top .menu .item {
  padding: 8px 16px;
  width: 240px;
  font-size: 16px;
}
.nav-top .menu .item:hover {
  background: rgba(0,0,0,0.1);
  cursor: pointer;
}
.nav-top .hidden-backdrop {
  position:fixed;
  top: 0;
  left: 0;
  right:0;
  bottom:0;
  z-index: 101;
}
.mobile:not(.laptop) .nav-top {
  --height: 38px;
  padding: 8px;
  max-width: calc(100vw - 8px);
}
.mobile:not(.laptop) .nav-top .settings {
  height: var(--height);
  width: var(--height);
}
.mobile:not(.laptop) .nav-top .settings .icon {
  height: 100%;
  padding: 4px;
}

.laptop .nav-top .logo {
  width: 54px;
  height: 54px;
  padding: 2px;
}
.show_navleft.laptop .nav-top .logo {
  display: none;
}
.mobile:not(.laptop) .nav-top .logo {
  width: 42px;
  height: 42px;
  padding: 2px;
}
.mobile:not(.laptop) .nav-top .search {
  margin: 0 8px;
  padding: 0;
}
.mobile:not(.laptop) .nav-top .search button {
  width: 42px;
  padding: 12px;
}
.mobile:not(.laptop) .nav-top .settings,
.mobile:not(.laptop) .nav-top .search,
.mobile:not(.laptop) .nav-top .search button {
  max-height: 100%;
}
.mobile:not(.laptop) .nav-top .search input {
  min-width: 0;
  width: 100%;
}
.mobile:not(.laptop) .nav-top .new-idea {
  font-size: 12px;
  margin-right: 8px;
  padding: 8px;
}
</style>
